import Header from 'notifications_config/components/list/NotificationsConfigListHeader';
import Filters from 'notifications_config/components/list/NotificationsConfigListFilters';
import Table from 'notifications_config/components/list/NotificationsConfigListTable';
import Row from 'notifications_config/components/list/NotificationsConfigListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/list/index.js